import React from "react";
import { Route } from "react-router";

const Login = React.lazy(() => import("./../screens/auth/login"));
const ResetPassword = React.lazy(
  () => import("./../screens/auth/ResetPassword")
);

const Admins = React.lazy(() => import("../screens/admins/AdminList"));
const AdminProfile = React.lazy(() => import("../screens/admins/Profile"));
const Roles = React.lazy(() => import("../screens/admins/Roles"));
const Permissions = React.lazy(() => import("../screens/admins/Permissions"));



const Settings = React.lazy(() => import("screens/settings"));
const TranslationEditor = React.lazy(() => import("screens/translations/TranslationEditor"));
const BlogList = React.lazy(() => import("screens/blog/BlogList"));
const AttributeList = React.lazy(
  () => import("screens/attributres/AttributeList")
);
const SurveyList = React.lazy(() => import("screens/survey/SurveyList"));
const CompanySectorList = React.lazy(
  () => import("screens/company-sector/CompanySectorList")
);

//Mail
const PageList = React.lazy(() => import("screens/pages/PageList"));
const PageGroupList = React.lazy(() => import("screens/page-groups/PageGroupList"));
const NavItemList = React.lazy(() => import("screens/navigation/NavItemList"));

// Forms
const ContactFormList = React.lazy(() => import("screens/forms/contact-form/ContactFormList"));
const ComplaintFormList = React.lazy(() => import("screens/forms/complaint-form/ComplaintFormList"));
const InformationUpdateFormList = React.lazy(() => import("screens/forms/information-update-form/InformationUpdateFormList"));
const SuggestionFormList = React.lazy(() => import("screens/forms/suggestion-form/SuggestionFormList"));
const ConsultancySupportFormList = React.lazy(() => import("screens/forms/consultancy-support-form/ConsultancySupportFormList"));
const EducationFormList = React.lazy(() => import("screens/forms/education-form/EducationFormList"));

// Events
const EventList = React.lazy(() => import("screens/events/EventList"));
const EventParticipations = React.lazy(() => import("screens/events/EventParticipations"));
const CustomerCommentList = React.lazy(() => import("screens/customer-comment/CustomerCommentList"));
const FaqList = React.lazy(() => import("screens/faq/FaqList"));
const TeamList = React.lazy(() => import("screens/team/TeamList"));


export const publicRoutes = [
  {
    path: "/",
    pageType: "blog",
    Content: BlogList,
  },
  {
    path: "/customer-comments",
    Content: CustomerCommentList,
    pageType: "settings",
  },
  {
    path: "/faqs",
    Content: FaqList,
    pageType: "settings",
  },
  {
    path: "/team",
    Content: TeamList,
    pageType: "settings",
  },

  //Attribute pages start
  {
    path: "/attributes/:type",
    pageType: "attribute",
    Content: AttributeList,
  },
  //Attribute pages end

  {
    path: "/surveys",
    pageType: "survey",
    Content: SurveyList,
  },
  {
    path: "/profile",
    pageType: "profile",
    Content: AdminProfile,
  },
  {
    path: "/admins",
    pageType: "admin",
    Content: Admins,
  },
  {
    path: "/admins/detail/:id",
    pageType: "admin",
    Content: AdminProfile,
  },
  {
    path: "/roles",
    pageType: "role",
    Content: Roles,
  },
  // {
  //   path: "/roles/pages/:id",
  //   pageType: "role",
  //   Content: RolePages,
  //   route: Route,
  // },
  {
    path: "/roles/permissions/:id",
    pageType: "role",
    Content: Permissions,
  },
  {
    path: "/settings/:page/:tab",
    pageType: "settings",
    Content: Settings,
  },
  {
    path: "/translations",
    pageType: "settings",
    Content: TranslationEditor,
  },

  {
    path: "/set-password/:userId/:token",
    Content: ResetPassword,
    pageType: "user",
  },
  {
    path: "/company-sectors",
    Content: CompanySectorList,
    pageType: "c_sector",
  },
  {
    path: "/pages",
    Content: PageList,
    pageType: "page",
  },
  {
    path: "/page-groups",
    Content: PageGroupList,
    pageType: "page",
  },
  {
    path: "/navigation",
    Content: NavItemList,
    pageType: "nav",
  },
  {
    path: "/navigation/:first",
    Content: NavItemList,
    pageType: "nav",
  },
  {
    path: "/navigation/:first/:second",
    Content: NavItemList,
    pageType: "nav",
  },
  {
    path: "/contact-forms",
    Content: ContactFormList,
    pageType: "contact_form",
  },
  {
    path: "/complaint-forms",
    Content: ComplaintFormList,
    pageType: "contact_form",
  },
  {
    path: "/information-update-forms",
    Content: InformationUpdateFormList,
    pageType: "contact_form",
  },
  {
    path: "/suggestion-forms",
    Content: SuggestionFormList,
    pageType: "contact_form",
  },
  {
    path: "/consultancy-support-forms",
    Content: ConsultancySupportFormList,
    pageType: "contact_form",
  },
  {
    path: "/education-forms",
    Content: EducationFormList,
    pageType: "contact_form",
  },
  {
    path: "/events",
    Content: EventList,
    pageType: "event",
  },
  {
    path: "/event-participations/:eventId",
    Content: EventParticipations,
    pageType: "event",
  },
];

export const authRoutes = [
  {
    path: "/set-password/:userId/:token",
    Content: ResetPassword,
  },
  {
    path: "*",
    Content: Login,
  },
];
